module.exports = "<main fxFill fxFlex>\n    <router-outlet></router-outlet>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main